import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const Wrapper: StyleRule = ({ whereToBuyEnabled }) => ({
    display: 'grid',
    height: pxToRem(48),
    marginBottom: whereToBuyEnabled ? 0 : pxToRem(8),
});

export const Container: StyleRule = () => ({
    display: 'grid',
    gridTemplateColumns: `1fr ${pxToRem(48)}`,
});

export const SaveToDesignBoardMobile: StyleRule = ({ theme }) => ({
    border: `${pxToRem(2)} solid ${theme.siteVariables.colors.charcoal[250]}`,
    '& > div': {
        height: pxToRem(16),
    },
});

export const ButtonHeart: StyleRule = ({ theme }) => ({
    cursor: 'pointer',
    [`& .${buttonClassName}:hover`]: {
        background: 'transparent',
    },
    ['& .' + svgIconClassName]: {
        [theme.screen.tablet]: {
            width: pxToRem(22),
            height: pxToRem(22),
        },
    },
});

export const SaveShareContainer: StyleRule = ({ theme }) => ({
    border: `${pxToRem(2)} solid ${theme.siteVariables.colors.charcoal[250]}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: pxToRem(48),
});

export const LinkButton: StyleRule = () => ({
    [`&.${buttonClassName} `]: {
        textDecoration: 'underline',
    },
    '& > span': {
        marginRight: pxToRem(10),
        padding: 0,
    },
});
